import React, { useState } from 'react';
import { ADS_ENABLED } from '../config/admob';

const AndroidPromoModal = ({ isOpen, onClose, perkName = 'This feature' }) => {
  const [copied, setCopied] = useState(false);
  const [showPerks, setShowPerks] = useState(true);

  if (!isOpen) return null;

  const isGeneralPromo = perkName === 'This feature' || perkName === 'All Android Perks';

  const handleCopyEmail = (e) => {
    e.preventDefault();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText('puzzl-rewards-testers@googlegroups.com');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '16px'
    }}>
      <div style={{
        background: 'linear-gradient(150deg, #181a26, #0e1017)',
        borderRadius: '20px',
        border: '2px solid #00e5ff',
        boxShadow: '0 0 40px rgba(0, 229, 255, 0.35)',
        width: '100%',
        maxWidth: '560px',
        maxHeight: '90vh',
        overflowY: 'auto',
        color: '#fff',
        padding: '28px',
        position: 'relative',
        boxSizing: 'border-box'
      }}>
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '18px',
            background: 'rgba(255, 255, 255, 0.08)',
            border: 'none',
            color: '#aaa',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            fontSize: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          title="Close"
        >
          &times;
        </button>

        {/* Header Icon & Title */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '68px',
            height: '68px',
            margin: '0 auto 14px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #00e5ff, #00c853)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '34px',
            boxShadow: '0 0 25px rgba(0, 229, 255, 0.45)'
          }}>
            🤖
          </div>

          <h2 style={{
            margin: '0 0 6px',
            fontSize: '1.7em',
            color: '#00e5ff',
            fontWeight: 'bold',
            letterSpacing: '0.5px'
          }}>
            {isGeneralPromo ? 'WHATIF Android Closed Beta' : 'Android Exclusive Perk'}
          </h2>

          <p style={{
            fontSize: '0.92em',
            color: '#ccc',
            lineHeight: '1.5',
            margin: '0 auto',
            maxWidth: '460px'
          }}>
            {!isGeneralPromo ? (
              <>
                <strong style={{ color: '#ff9800' }}>{perkName}</strong> is powered by rewarded ads exclusive to our official{' '}
                <span style={{ color: '#4caf50', fontWeight: 'bold' }}>Android Application</span>! Follow the 3 quick steps below to join the Closed Beta and install.
              </>
            ) : (
              <>
                Play <strong style={{ color: '#fff' }}>WHATIF Battle For Riches</strong> natively on Android with real-time alerts!
              </>
            )}
          </p>
        </div>

        {/* 3-Step Opt-In & Download Instructions */}
        <div style={{
          background: 'rgba(0, 0, 0, 0.45)',
          borderRadius: '14px',
          border: '1px solid rgba(0, 229, 255, 0.25)',
          padding: '16px',
          marginBottom: '20px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '14px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            paddingBottom: '8px'
          }}>
            <span style={{ fontSize: '0.95em', fontWeight: 'bold', color: '#00e5ff', textTransform: 'uppercase', letterSpacing: '1px' }}>
              📋 3-Step Opt-In & Install Guide
            </span>
            <span style={{ fontSize: '0.75em', color: '#ffb74d', background: 'rgba(255, 183, 77, 0.12)', padding: '2px 8px', borderRadius: '10px' }}>
              Google Play Closed Beta
            </span>
          </div>

          {/* STEP 1 */}
          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '14px',
            background: 'rgba(255, 255, 255, 0.03)',
            padding: '12px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.05)'
          }}>
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#00e5ff',
              color: '#000',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '14px'
            }}>
              1
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', fontSize: '0.92em', color: '#fff', marginBottom: '2px' }}>
                Join the Google Testers Group
              </div>
              <div style={{ fontSize: '0.82em', color: '#aaa', marginBottom: '8px' }}>
                Google Play requires your email to be part of the tester group before the download link becomes active.
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
                <a
                  href="https://groups.google.com/g/puzzl-rewards-testers"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '7px 14px',
                    background: 'linear-gradient(135deg, #00e5ff, #0099b8)',
                    color: '#000',
                    borderRadius: '6px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    fontSize: '0.82em',
                    boxShadow: '0 0 10px rgba(0, 229, 255, 0.3)'
                  }}
                >
                  👥 Join Group on Web
                </a>
                <button
                  type="button"
                  onClick={handleCopyEmail}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: '#ddd',
                    padding: '7px 12px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.8em',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                  title="Copy tester group email"
                >
                  {copied ? '✓ Copied Email!' : '📋 Copy Group Email'}
                </button>
              </div>
            </div>
          </div>

          {/* STEP 2 */}
          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '14px',
            background: 'rgba(255, 255, 255, 0.03)',
            padding: '12px',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.05)'
          }}>
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#9c27b0',
              color: '#fff',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '14px'
            }}>
              2
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', fontSize: '0.92em', color: '#fff', marginBottom: '2px' }}>
                Join on the Web (Opt-In)
              </div>
              <div style={{ fontSize: '0.82em', color: '#aaa', marginBottom: '8px' }}>
                Visit the Google Play opt-in page and click <strong>"Become a Tester"</strong> using your Google Play account.
              </div>
              <a
                href="https://play.google.com/apps/testing/app.rewardsinwhatif.game"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '7px 14px',
                  background: 'linear-gradient(135deg, #ba68c8, #7b1fa2)',
                  color: '#fff',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '0.82em',
                  boxShadow: '0 0 10px rgba(186, 104, 200, 0.3)'
                }}
              >
                🌐 Opt-In on the Web
              </a>
            </div>
          </div>

          {/* STEP 3 */}
          <div style={{
            display: 'flex',
            gap: '12px',
            background: 'rgba(76, 175, 80, 0.08)',
            padding: '12px',
            borderRadius: '10px',
            border: '1px solid rgba(76, 175, 80, 0.3)'
          }}>
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#4caf50',
              color: '#fff',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '14px'
            }}>
              3
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', fontSize: '0.92em', color: '#81c784', marginBottom: '2px' }}>
                Download on Android (Google Play)
              </div>
              <div style={{ fontSize: '0.82em', color: '#aaa', marginBottom: '8px' }}>
                Once opted in, install WHATIF Battle For Riches straight from Google Play!
              </div>
              <a
                href="https://play.google.com/store/apps/details?id=app.rewardsinwhatif.game"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '9px 18px',
                  background: 'linear-gradient(135deg, #4caf50, #2e7d32)',
                  color: '#fff',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '0.86em',
                  boxShadow: '0 0 15px rgba(76, 175, 80, 0.4)'
                }}
              >
                📲 Download on Google Play
              </a>
            </div>
          </div>
        </div>

        {/* Toggleable Android Perks */}
        {ADS_ENABLED && (
          <div style={{ marginBottom: '20px' }}>
            <button
              type="button"
              onClick={() => setShowPerks(!showPerks)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#00e5ff',
                fontSize: '0.85em',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 0',
                margin: '0 auto'
              }}
            >
              <span>{showPerks ? '▼' : '►'}</span>
              <span>Why play on Android? View Exclusive Perks</span>
            </button>

            {showPerks && (
              <div style={{
                background: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '12px',
                padding: '14px 16px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                fontSize: '0.85em',
                textAlign: 'left'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.2em' }}>⚡</span>
                  <div>
                    <strong style={{ color: '#ffeb3b' }}>Torch of Haste:</strong>
                    <span style={{ color: '#aaa', marginLeft: '6px' }}>Watch a video to shave 30 minutes off an active expedition (3x/day)</span>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.2em' }}>🔥</span>
                  <div>
                    <strong style={{ color: '#ff7043' }}>Campfire Rest:</strong>
                    <span style={{ color: '#aaa', marginLeft: '6px' }}>Watch a video to recover +50 Stamina (3x/day)</span>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.2em' }}>👑</span>
                  <div>
                    <strong style={{ color: '#ffd700' }}>Goblin's Greed (2x Doubler):</strong>
                    <span style={{ color: '#aaa', marginLeft: '6px' }}>Watch a video to double a run's Daily Points and XP (5x/day)</span>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.2em' }}>🔮</span>
                  <div>
                    <strong style={{ color: '#e040fb' }}>Dragon Shrine Blessings:</strong>
                    <span style={{ color: '#aaa', marginLeft: '6px' }}>Watch a video for +25% MP, +20% Speed, or +25% XP (3x/day)</span>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.2em' }}>🎰</span>
                  <div>
                    <strong style={{ color: '#00e5ff' }}>Wheel of Riches:</strong>
                    <span style={{ color: '#aaa', marginLeft: '6px' }}>One free spin a day, plus 3 by watching a video, for Daily Points, Stamina or XP. Chances are shown on the wheel.</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Action Button */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 24px',
              backgroundColor: '#262938',
              color: '#ccc',
              border: '1px solid #444',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '0.9em'
            }}
          >
            Close
          </button>
          <a
            href="https://play.google.com/apps/testing/app.rewardsinwhatif.game"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '10px 22px',
              background: 'linear-gradient(135deg, #00e5ff, #008699)',
              color: '#000',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: 'bold',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '0.9em',
              boxShadow: '0 0 15px rgba(0, 229, 255, 0.4)'
            }}
          >
            🚀 Start Opt-In
          </a>
        </div>
      </div>
    </div>
  );
};

export default AndroidPromoModal;
